import { datadogLogs } from '@datadog/browser-logs'
import { useParams } from 'react-router'
import { ReactElement, useEffect, useRef } from 'react'

import Spinner from '../../components/spinner/Spinner'
import apiClientService from '../../utils/api'
import useAuth from '../../utils/auth/useAuth'
import { history } from '../../utils/historyStore'
import { SpinnerContainer } from '../showroom/vehicle-list/VehicleList.styled'
import { cleanSessionStorage } from '../vehicle-configurator/util/sessionStorageUtil'

const Logout = (): ReactElement => {
  const { logout, isAuthenticated, isLoading } = useAuth()
  const started = useRef(false)
  const { locale } = useParams<{ locale: string }>()

  useEffect(() => {
    const performLogout = () => {
      Promise.resolve(apiClientService.logout(locale))
        .catch((error: unknown) => {
          datadogLogs.logger.error('Backend logout failed', { error })
        })
        .finally(() => {
          localStorage.removeItem('welcomeMessage')
          cleanSessionStorage([])
          logout()
        })
    }

    if (!isLoading && !started.current) {
      started.current = true
      if (isAuthenticated) {
        performLogout()
      } else {
        history.push('/')
      }
    }
  }, [isLoading, isAuthenticated, logout, locale])

  return (
    <SpinnerContainer>
      <Spinner size={20} />
    </SpinnerContainer>
  )
}

export default Logout
